import {api} from '../index';
import {InventoryManagementState} from '../../redux/stateResponses/inventoryManagement';
import {Item} from '../../redux/entities/inventory/item';
import {Category} from '../../redux/entities/inventory/category';
import {Dictionary} from '../../types';
import {ProductSelectionState} from '../../redux/stateResponses/productSelectionState';
import {EOrderStatus, Order} from '../../redux/entities/inventory/order';
import {Program} from '../../redux/entities/inventory/program';
import {House} from '../../redux/entities/inventory/house';
import {UpdateProfilePictureRequest} from '../../pages/private/Profile/components/ProfilePicture';
import {User} from '../../redux/entities/user';
import {UpdateItemPictureRequest} from '../../components/util/ItemPicture/ItemPicture';
import {UpsertItemRequest} from '../../pages/private/Configuration/InventoryManagement/components/ItemModal/ItemModal';
import {OrderUpdate} from '../../pages/private/Configuration/OrderManagement/components/OrderModal';
import {Transfer} from "../../redux/entities/inventory/transfer";

export type TransferInventoryFrom = 'Store' | 'Warehouse';

export async function getInventoryManagementState() {
  return (await api.get<InventoryManagementState>('/Inventory/management')).data;
}

export async function getProductSelectionState() {
  return (await api.get<ProductSelectionState>('/PublicOrder')).data;
}

export async function upsertItem(item: UpsertItemRequest) {
  return (await api.post<Item>('/Inventory', item)).data;
}

export async function archiveItem(id: string) {
  return (await api.post<Item>(`/Inventory/${id}/archive`)).data;
}

export async function updateItemPicture(request: UpdateItemPictureRequest) {
  return (await api.post<Item>('/Inventory/itemPicture', request)).data;
}


export async function upsertCategory(category: Category) {
  return (await api.post<Category>('/Inventory/category', category)).data;
}

export interface UpsertCategoriesRequest {
  updateList: Category[];
  deleteIds: string[];
}

export async function upsertCategories(editedCategories: UpsertCategoriesRequest) {
  return (await api.post<Dictionary<Category>>('/Inventory/categories', editedCategories)).data;
}

export async function upsertOrder(order: OrderUpdate) {
  return (await api.post<Order>('Order/withdraw', order)).data;
}

export async function submitOrderStatus(id: string, status: EOrderStatus) {
  console.log(status);
  return (await api.post<Order>(`/Order/orderStatus/${id}/${status}`)).data;
}

export async function cancelOrder(id: string) {
  return (await api.post<Order>(`/Order/cancel/${id}`)).data;
}

export async function deleteOrder(id: string) {
  return (await api.delete(`/Order/delete/${id}`)).data;
}

export async function submitPublicOrder(order: Order) {
  return (await api.post('/PublicOrder', order)).data;
}

export async function transferInventory(req: Transfer) {
  return (await api.post<Item>('/Inventory/transfer', req)).data;
}

export async function upsertDeposit(req: Order) {
  return (await api.post<Order>('Order/deposit', req)).data;
}

export async function upsertProgram(req: {id: string, name: string, archivedAt?: string | null}) {
  return (await api.post<Program>('Order/program', req)).data;
}

export async function archiveProgram(id: string) {
  return (await api.post<Program>(`/Order/program/archive/${id}`)).data;
}

export async function restoreProgram(id: string) {
  return (await api.post<Program>(`/Order/program/archive/${id}`)).data;
}

export async function upsertHouse(req: {id: string, name: string, archivedAt?: string | null}) {
  return (await api.post<House>('Order/house', req)).data;
}

export async function archiveHouse(id: string) {
  return (await api.post<House>(`/Order/house/archive/${id}`)).data;
}

export async function restoreHouse(id: string) {
  return (await api.post<House>(`/Order/house/arvhive/${id}`)).data;
}
